const ADF_METHOD = [
  { label: 'additionalDeliveryMethod1', value: '현금' },
  { label: 'additionalDeliveryMethod2', value: '계좌' },
  { label: 'additionalDeliveryMethod3', value: '취소' },
];

export default ADF_METHOD;
